import Vue from 'vue'

import {
  SaasImg,
  UserSurplus
} from '@/components'

Vue.component('SaasImg', SaasImg)
Vue.component('UserSurplus', UserSurplus)